import L, { Point } from "leaflet";
import DroneIcon from "./drone.svg"
import CopterIcon from "./copter.svg"
import CopterOfflineIcon from "./copter_offline.svg"
import PlaneIcon from "./plane.svg"
import PlaneOfflineIcon from "./plane_offline.svg"

export const GPSMapDroneIcon = new L.Icon({
    iconUrl: DroneIcon,
    iconRetinaUrl: DroneIcon,
    iconAnchor: new L.Point(10, 30),
    popupAnchor: new L.Point(0, 0),
    backgroundColor: "rgba(0,0,0,0)",
    iconSize: new Point(22, 72),
});

export const GPSMapCopterIcon = new L.Icon({
    iconUrl: CopterIcon,
    iconRetinaUrl: CopterIcon,
    iconAnchor: new L.Point(10, 30),
    popupAnchor: new L.Point(0, 0),
    backgroundColor: "rgba(0,0,0,0)",
    iconSize: new Point(40, 40),
});

export const GPSMapCopterOfflineIcon = new L.Icon({
    iconUrl: CopterOfflineIcon,
    iconRetinaUrl: CopterOfflineIcon,
    iconAnchor: new L.Point(10, 30),
    popupAnchor: new L.Point(0, 0),
    backgroundColor: "rgba(0,0,0,0)",
    iconSize: new Point(40, 40),
});

export const GPSMapPlaneMapIcon = new L.Icon({
    iconUrl: PlaneIcon,
    iconRetinaUrl: PlaneIcon,
    iconAnchor: new L.Point(10, 30),
    popupAnchor: new L.Point(0, 0),
    backgroundColor: "rgba(0,0,0,0)",
    iconSize: new Point(40, 40),
});

export const GPSMapPlaneOfflineMapIcon = new L.Icon({
    iconUrl: PlaneOfflineIcon,
    iconRetinaUrl: PlaneOfflineIcon,
    iconAnchor: new L.Point(10, 30),
    popupAnchor: new L.Point(0, 0),
    backgroundColor: "rgba(0,0,0,0)",
    iconSize: new Point(40, 40),
});
